module.exports = __webpack_public_path__ + "img/2E2E2D_7D7C76_A3A39F_949C94-256px.686871ed.png";